<template>
  <div>
    <section>
      <b-tabs
        v-model="tabIndex"
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >
        <!-- Listado de cupones-->
        <b-tab lazy>
          <template #title>
            <feather-icon
              icon="ListIcon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">Listado de cupones</span>
          </template>

          <cupon-list />
        </b-tab>

        <!-- Nuevo cupón -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="PlusCircleIcon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">Nuevo cupón</span>
          </template>

          <!-- Alta nuevo cupón (steps) -->
          <edit-cupon @refetch-data="tabIndex = 0" />
        </b-tab>
      </b-tabs>
    </section>

  </div>
</template>

<script>
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'
import CuponList from './components/edicion-cupon/CuponList.vue'
import EditCupon from './components/edicion-cupon/components/EditCupon.vue'

export default {
  components: {
    BTabs,
    BTab,
    CuponList,
    EditCupon,
  },
  data: () => ({
    tabIndex: 0,
  }),
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
